import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "@/config/site";

const NAV = [
  { to: "/services", label: "Services" },
  { to: "/process", label: "Process" },
  { to: "/products", label: "Products" },
  { to: "/reviews", label: "Reviews" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <nav
      data-testid="site-header"
      className="sticky top-0 z-50 bg-cloud/95 border-b border-line backdrop-blur-md"
    >
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <img
            src="/logo.png"
            alt={`${SITE.companyName} — ${SITE.tagline}`}
            data-testid="brand-logo"
            className="h-11 w-auto"
            width="168"
            height="44"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-ink">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `transition-colors hover:text-royal ${isActive ? "text-royal" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-cta-button"
            className="hidden sm:inline-block px-5 py-2.5 rounded bg-royal hover:bg-royal-dark text-white text-xs font-mono-sub font-bold uppercase tracking-wider transition-colors"
          >
            Request a Consultation
          </Link>
          <button
            data-testid="mobile-menu-button"
            className="md:hidden p-2 text-steel"
            onClick={() => setOpen(!open)}
            aria-label="Toggle navigation menu"
            aria-expanded={open}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-line bg-cloud px-6 py-4 flex flex-col gap-4 text-sm font-medium text-ink"
        >
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
              className="hover:text-royal transition-colors"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="mobile-cta-button"
            className="px-5 py-2.5 rounded bg-royal text-white text-xs font-mono-sub font-bold uppercase tracking-wider text-center"
            onClick={() => setOpen(false)}
          >
            Request a Consultation
          </Link>
        </div>
      )}
    </nav>
  );
}
